<div *ngIf="isLoading" class="overlay">
  <div class="spinner"></div>
</div>
<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row justify-content-center">
      <div class="col-3 col-md-2" *ngFor="let card of resumenCards; index as i">
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-5">
                <div
                  class="icon-big text-center text-dark rounded shadow"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>
              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-8">
        <div class="card-tools">
          <a [routerLink]="['/numbers/accounting']" class="btn btn-dark btn-sm btn-new">
            Staff
          </a>
          <a
            [routerLink]="['/numbers/accounting/freelancers']"
            class="btn btn-dark btn-sm btn-new"
          >
            Freelancers
          </a>
          <a
            [routerLink]="['/numbers/accounting/drivers']"
            class="btn btn-dark btn-sm btn-new"
          >
            Driver & +
          </a>
          <a
            [routerLink]="['/numbers/accounting/customers']"
            class="btn btn-dark btn-sm btn-new"
          >
            Customers
          </a>
          <a
            [routerLink]="['/numbers/accounting/quickbooks/expenses']"
            class="btn btn-dark btn-sm btn-new"
          >
            Bills
          </a>
        </div>
        <div class="card">
          <div class="card-header card-header-icon d-flex align-items-center">
            <div class="card-icon">
              <i class="material-icons">receipt</i>
            </div>
            <h4 class="card-title mb-0 me-3 flex-grow-1">
              {{ id ? "Update" : "New" }} Bill
            </h4>
            <div class="ms-auto">
              <i
                class="fas fa-edit text-dark icon__edit"
                (click)="enableUpdate()"
              ></i>
            </div>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <!-- Información Básica -->
              <div class="row" *ngIf="isPayroll">
                <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="vendorId"
                      >vendorId</label
                    >
                    <select
                      class="form-control select"
                      id="vendorId"
                      formControlName="vendorId"
                      [ngClass]="{ disabled__select: !update }"
                    >
                      <option value="" disabled>Select a vendor</option>
                      <option *ngFor="let item of vendors" [value]="item.Id">
                        {{ item.DisplayName }}
                      </option>
                    </select>
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('vendorId')"
                    >
                      vendorId is required
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <!-- <div class="col-6">
                  <label for="paymentAccountId">Account Type</label>
                  <select
                    class="form-control select"
                    id="paymentAccountId"
                    formControlName="paymentAccountId"
                    [ngClass]="{ disabled__select: !update }"
                  >
                    <option value="" disabled>Select</option>
                    <option
                      *ngFor="let item of paymentAccounts"
                      [value]="item.Id"
                    >
                      {{ item.Name }}
                    </option>
                  </select>
                </div> -->
                <div class="col-3 col-md-3">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="txnDate">Date</label>
                    <input
                      type="date"
                      class="form-control"
                      id="txnDate"
                      formControlName="txnDate"
                      [readOnly]="!update"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('txnDate')"
                    >
                      txnDate is required
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 col-md-12">
                  <div formArrayName="lines">
                    <div
                      *ngFor="let line of lines.controls; let i = index"
                      [formGroupName]="i"
                      class="row mb-2"
                    >
                      <!-- <div class="col-5">
                        <label for="accountName">Item</label>
                        <select
                          class="form-control select"
                          id="accountName"
                          formControlName="accountName"
                          [ngClass]="{ disabled__select: !update }"
                        >
                          <option value="" disabled>Select a item</option>
                          <option
                            *ngFor="let item of categories"
                            [value]="item.Name"
                            (click)="setItem(i, item.Id)"
                          >
                            {{ item.Name }}
                          </option>
                        </select>
                      </div> -->

                      <div class="col-3">
                        <label for="amount">Amount</label>
                        <input
                          type="number"
                          class="form-control"
                          formControlName="amount"
                          [readOnly]="!update"
                        />
                      </div>

                      <div class="col-8">
                        <label for="description">Description</label>
                        <input
                          type="text"
                          class="form-control"
                          placeholder=""
                          formControlName="description"
                          [readOnly]="!update"
                        />
                      </div>

                      <div
                        class="col-1 d-flex align-items-end justify-content-center"
                      >
                        <button
                          type="button"
                          class="btn btn-link text-dark btn-sm btn-del"
                          [disabled]="!update"
                          (click)="removeLine(i)"
                        >
                          <i class="fas fa-trash"></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <button
                    type="button"
                    class="btn btn-dark btn-sm mt-2 btn-create"
                    [disabled]="!update"
                    (click)="addLine()"
                  >
                    Add
                  </button>
                </div>
              </div>

              <div class="row">
                <!-- <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label
                        class="bmd-label-floating"
                        for="paymentMethodRefValue"
                        >Payment Method Ref Name</label
                      >
                      <select
                        class="form-control select"
                        id="paymentMethodRefValue"
                        formControlName="paymentMethodRefValue"
                        [ngClass]="{ disabled__select: !update }"
                      >
                        <option value="" disabled>Select a payment method</option>
                        <option
                          *ngFor="let item of paymentMethods"
                          [value]="item.value"
                          (click)="setPayment(item.name)"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('paymentMethodRefValue')"
                      >
                        payment method RefName is required
                      </div>
                    </div>
                  </div> -->
                <!-- <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="description"
                      >Description</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="description"
                      formControlName="description"
                      [readOnly]="!update"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('description')"
                    >
                      Description is required
                    </div>
                  </div>
                </div> -->
              </div>

              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <div
                    class="form-group d-flex justify-content-center align-items-center gap-4"
                  >
                    <div class="custom-control custom-switch mt-4 checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="status"
                        formControlName="status"
                      />
                      <label class="custom-control-label" for="status"
                        >Active</label
                      >
                    </div>
                  </div>
                </div>
              </div>

              <button
                type="submit"
                class="btn btn-dark pull-right btn-create d-flex m-auto"
                [disabled]="form.invalid"
              >
                {{ id ? "Update" : "Create" }}
              </button>
              <div class="clearfix"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
